import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'out-location-footer',
  imports: [CommonModule, RouterLink],
  templateUrl: './location-footer.component.html',
  styleUrl: './location-footer.component.scss',
})
export class LocationFooterComponent {
  states = [
    'California',
    'Florida',
    'Arizona',
    'Texas',
    'Nevada',
    'New York',
    'Illinois',
    'Georgia',
    'Virginia',
    'New Jersey',
  ];

  models = [
    {
      link: '/used-tesla-cybertruck-for-sale',
      text: 'Used Cybertruck For Sale',
    },
    { link: '/used-tesla-model-s-for-sale', text: 'Used Model S For Sale' },
    { link: '/used-tesla-model-3-for-sale', text: 'Used Model 3 For Sale' },
    { link: '/used-tesla-model-x-for-sale', text: 'Used Model X For Sale' },
    { link: '/used-tesla-model-y-for-sale', text: 'Used Model Y For Sale' },
    { link: '/used-tesla-roadster-for-sale', text: 'Used Roadster For Sale' },
  ];

  supportLinks = [
    {
      name: 'About Us',
      link: '/about-only-used-tesla',
    },
    {
      name: 'Contact Us',
      link: '/contact',
    },
    {
      name: 'Tesla News',
      link: 'https://blog.onlyusedtesla.com/',
      unique: true,
    },
    {
      name: 'Frequently Asked Question',
      link: '/frequently-asked-questions',
    },
    {
      name: 'Fraud Awareness',
      link: '/fraud-awareness',
    },
    {
      name: 'Contact Us',
      link: '/contact-us',
    },
  ];
}
